/**
 * @file The one rule deciding whether a label is offered. Consumers: the
 * attachment and communication log pickers, which build their options from it,
 * and `deriveLabelRows`, whose offered column is what an administrator reads to
 * predict what those pickers will do.
 *
 * Archiving a group withholds its labels without touching their own `archived`
 * flag, which is why both flags are read and neither is written — un-archiving
 * the group restores exactly the labels that were not archived in their own
 * right. An item already carrying a label is always offered it, so an
 * assignment can be taken off however the definition was retired. It lives
 * beside `LabelTags` because the settings tree and the rendering tree both
 * already import from here and neither may depend on the other.
 */

import type { Label, LabelGroup, LabelId } from '#types';

export const labelIsOffered = (
    group: Pick<LabelGroup, 'archived'>,
    label: Pick<Label, 'id' | 'archived'>,
    assigned?: ReadonlySet<LabelId>,
): boolean => assigned?.has(label.id) === true || (!label.archived && !group.archived);
